import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import ComponentLayout from '../../../src/layouts/component-layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h2>{`Anatomy`}</h2>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/912236/5cda0c94-c120-4fc6-8306-8b55012dee0a",
        "alt": "Ordered list renders as a numbered list of items"
      }}></img></p>
    <h2>{`Usage`}</h2>
    <p>{`Use an ordered list to represent a list of items in a numerical order.`}</p>
    <p>{`A number indicating the items relative position in the sequence will be prepended to each item in the list.`}</p>
    <p>{`The ordered list is commonly used when presenting sequential or step-by-step information. It is suitable for instructions, procedures, tutorials, or any content that follows a specific order. Ensure that the items in the ordered list are logically organized and follow a clear progression. This helps readers understand the sequence of information and makes it easier to follow.`}</p>
    <p>{`Avoid overusing ordered lists. Reserve them for situations where the order of items is genuinely meaningful or where a clear sequence needs to be conveyed. For
lists that don't require a specific order, consider using an `}<a parentName="p" {...{
        "href": "/components/UnorderedList"
      }}>{`unordered list`}</a>{` instead.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/40022d10-248f-45d5-acce-2917a72d7b12" alt="" />
    <Caption mdxType="Caption">Use an ordered list to present a sequence of steps.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/e9dd1ee2-cfa7-40d4-a8b6-2416cf99cdae" alt="" />
    <Caption mdxType="Caption">
      Don't use an ordered list to present a list of items that don't require a
      specific order. Use an unordered list instead.
    </Caption>
  </Dont>
    </DoDontContainer>
    <p>{`The ordered list should have concise and short items. Avoid using long sentences or paragraphs as they can be difficult to scan and comprehend. If you need to include a long item or even headings and links, consider using a `}<a parentName="p" {...{
        "href": "/components/Pillar"
      }}>{`pillar`}</a>{`, a `}<a parentName="p" {...{
        "href": "/components/Card"
      }}>{`card`}</a>{` or a `}<a parentName="p" {...{
        "href": "/components/River"
      }}>{`river`}</a>{` instead.`}</p>
    <DoDontContainer mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/912236/181f1cb9-05bc-4010-a80b-a978b7ffbe56" alt="" />
    <Caption mdxType="Caption">Use an ordered list for short and concise content items.</Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/912236/28950f6a-d7f0-4d9d-bb70-02c062d309f3" alt="" />
    <Caption mdxType="Caption">
      Don't use an ordered list for long and rich sentences, paragraphs,
      headings or links. Use a pillar, card or river components instead.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/UnorderedList"
        }}>{`Unordered list`}</a>{`: to display a list of plain content items.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Pillar"
        }}>{`Pillar`}</a>{`: To display related content with less visual emphasis.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Card"
        }}>{`Card`}</a>{`: to display navigational related content with higher visual weight.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/River"
        }}>{`River`}</a>{`: To display a list of content items with a visual asset.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      